module.exports = __webpack_public_path__ + "static/img/6326_phase_function_Paper_PointsHejduk_Prediction.f20743a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6326_phase_function_Paper_PointsHejduk_Prediction.png
// module id = x0I2
// module chunks = 0